import type { CrewMember } from '../../../app/entities/crew-member';

export interface CrewFilter {
  department?: string[];
  team?: string[];
  role?: string;
  q?: string;
}

/**
 * Mirrors `apps/api/src/project/crew/lib/filter-crew.ts` deliberately. The screen filters in
 * memory; the export endpoint applies the same predicate server-side. Change one and change both,
 * or an export will quietly disagree with what the user is looking at.
 *
 * `department` and `team` are multi-select: unfiltered when the array is empty or absent,
 * otherwise the member's value must be in the array. `role` stays single-value.
 */
export const filterCrew = (members: CrewMember[], query: CrewFilter): CrewMember[] => {
  const needle = query.q?.trim().toLowerCase();

  return members.filter((member) => {
    if (query.department?.length && !query.department.includes(member.department)) return false;
    if (query.team?.length && !query.team.includes(member.team)) return false;
    if (query.role && member.role !== query.role) return false;

    if (!needle) return true;

    return [member.name, member.role, member.department, member.team, member.email]
      .join(' ')
      .toLowerCase()
      .includes(needle);
  });
};
